import React from 'react';
import { TestTube, Calendar, FileText, Truck } from 'lucide-react';
import { Link } from 'react-router-dom';

interface PageHeaderProps {
  onShowMonthlyListModal?: () => void;
  onShowShippingListModal?: () => void;
  hasLocationFeature?: boolean;
  organizationLocations?: Array<{ id: string; name: string }>;
  selectedLocationFilter?: string;
  mainLocationFilterValue?: string;
  onLocationFilterChange?: (locationId: string) => void;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  onShowMonthlyListModal,
  onShowShippingListModal,
  hasLocationFeature = false,
  organizationLocations = [],
  selectedLocationFilter = '',
  mainLocationFilterValue = '__main_location__',
  onLocationFilterChange
}) => {
  return (
    <div className="flex flex-col gap-4 mb-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white flex items-center gap-2">
            <TestTube className="h-7 w-7 text-emerald-500" />
            Probenverwaltung
          </h1>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            Verwalten Sie alle geplanten und einbestellten Proben
          </p>
        </div>

        <div>
          <Link
            to="/samples-calendar"
            className="inline-flex items-center px-3 py-1.5 sm:px-4 sm:py-2 border border-transparent text-xs sm:text-sm font-medium rounded-md shadow-sm text-white bg-emerald-600 hover:bg-emerald-700"
          >
            <Calendar className="h-4 w-4 mr-2" />
            Kalenderansicht
          </Link>
        </div>

        <div className="flex gap-2">
          <button
            onClick={onShowMonthlyListModal}
            className="inline-flex items-center px-3 py-1.5 sm:px-4 sm:py-2 border border-gray-300 dark:border-gray-600 text-xs sm:text-sm font-medium rounded-md shadow-sm text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700"
          >
            <FileText className="h-4 w-4 mr-2" />
            Monatliche Probenliste
          </button>

          <button
            onClick={onShowShippingListModal}
            className="inline-flex items-center px-3 py-1.5 sm:px-4 sm:py-2 border border-gray-300 dark:border-gray-600 text-xs sm:text-sm font-medium rounded-md shadow-sm text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700"
          >
            <Truck className="h-4 w-4 mr-2" />
            Probenversand
          </button>
        </div>
      </div>

      {hasLocationFeature && (
        <div className="w-full sm:w-auto sm:max-w-sm">
          {/* Standort-Filter für die Probenliste: leer zeigt alle, Hauptstandort zeigt Kunden ohne Standort. */}
          <label htmlFor="sample-location-filter" className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
            Standort
          </label>
          <select
            id="sample-location-filter"
            value={selectedLocationFilter}
            onChange={(event) => onLocationFilterChange?.(event.target.value)}
            className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-emerald-500"
          >
            <option value="">Alle Standorte</option>
            <option value={mainLocationFilterValue}>Hauptstandort</option>
            {organizationLocations.map((location) => (
              <option key={location.id} value={location.id}>
                {location.name}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
};

export default PageHeader;
